var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bmui-searchbox_empty" }, [
    _vm._v(_vm._s(_vm.title || "查找不到结果"))
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18ad5eb1", { render: render, staticRenderFns: staticRenderFns })
  }
}